import { Injectable } from '@angular/core';
import { catchError, map } from "rxjs/operators";
import { throwError } from 'rxjs';
import { ApiService } from '../../core/services/index';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class imagesService {

    constructor(private _api: ApiService,private http: HttpClient) { 
    }


    getImageUploadLink(fileName,fileType,purpose){
        let httpParams = new HttpParams();
        httpParams = httpParams.append('fileName', fileName);
        httpParams = httpParams.append('fileType', fileType);
        httpParams = httpParams.append('purpose', purpose);
        return this._api.get(`${"images/upload-link?" + httpParams}`)
            .pipe(
                map((res:any) => res),
                catchError((error:any) => throwError(() => error))
            )
    }

    getCoinUploadAllowance() {
        return this._api.get('images/coin-upload-allowance').pipe(
            map((res:any) => res),
            catchError((error:any) => throwError(() => error))
        );
    }


    uploadFileToS3(signedRequest: string, file: File) {
        const headers = { 'Content-Type': file.type };
        return this.http.put(signedRequest, file, { headers, reportProgress: true, observe: 'events' })
        .pipe(
            map((res:any) => res),
            catchError((error:any) => throwError(() => error))
        );
    }
    
}
